export const VALID_EMAIL_CHARACTERS =
  "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890#!%$‘&+*–/=?^_`.{|}~@";
export const NUMBERS = "1234567890";
export const BASIC_KEYS = [
  "ArrowLeft",
  "ArrowUp",
  "ArrowDown",
  "ArrowRight",
  "Backspace",
];
